var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoramBigLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 50,
    viewBox: "0 0 151 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0316 26.6802V26.8806L16.1461 26.6802H16.0316Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7905 16.7739L19.3425 21.0696L16.0326 26.8808V26.8603L13.0089 21.7956L0 0H6.43388C6.43388 0 10.9351 0.153382 13.1776 2.83451C13.2574 2.9296 13.334 3.02879 13.4087 3.13105L21.5564 16.3945L21.7517 16.7126L21.7885 16.7729L21.7905 16.7739Z",
    fill: "url(#paint0_linear_9604_4443)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7906 16.7737L21.3489 17.5488L19.3426 21.0695L16.5879 25.9041L16.0316 26.8796V26.8591L14.8659 24.9061L14.0724 23.5767L13.0079 21.7934L8.27148 13.8584C8.35738 13.2234 10.518 10.439 12.2359 10.439L14.0509 9.9165C15.1348 9.9165 16.9989 10.5045 18.3037 11.0996L21.5554 16.3933L21.7507 16.7113L21.7875 16.7717L21.7906 16.7737Z",
    fill: "url(#paint1_linear_9604_4443)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8758 26.6802V48.1026C27.8114 48.7182 27.4525 49.8031 25.7264 49.8031H18.1872C16.4069 49.8031 16.0807 48.6507 16.0316 48.0474V46.4573L17.5798 35.6878L19.224 26.6802H27.8758Z",
    fill: "url(#paint2_linear_9604_4443)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8758 26.5425V48.1029C27.8114 48.7185 27.4525 49.8034 25.7264 49.8034H18.1872C16.4069 49.8034 16.0807 48.651 16.0316 48.0477V46.4577L19.224 41.0964L21.942 36.5328C22.4021 35.6575 22.9164 34.8047 23.442 33.9365C23.4625 33.9028 23.4829 33.8701 23.5034 33.8363C23.5371 33.7811 23.5699 33.7269 23.6026 33.6717C23.711 33.4938 23.8194 33.3148 23.9277 33.1349L25.074 31.2278L27.7705 26.6744L27.8758 26.5435V26.5425Z",
    fill: "url(#paint3_linear_9604_4443)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8491 0L29.0436 24.625L27.8421 26.6241L27.8083 26.6804L25.075 31.2266L23.9288 33.1337C23.8204 33.3136 23.712 33.4926 23.6036 33.6705C23.5709 33.7257 23.5371 33.781 23.5044 33.8351C23.484 33.8689 23.4635 33.9026 23.4431 33.9364C22.9164 34.8045 22.4021 35.6573 21.943 36.5326L16.0337 46.4575L15.9815 26.7714L19.2966 20.996V20.994H19.2987L21.7548 16.7146C21.8019 16.6328 29.29 3.58608 29.29 3.58608C29.29 3.58404 29.292 3.58301 29.2931 3.58199C31.2523 0.180991 36.5573 0 36.5573 0H43.8491Z",
    fill: "url(#paint4_linear_9604_4443)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150.902 9.79578V10.4819C150.902 12.1947 150.613 13.7346 150.038 15.1018C149.444 16.5109 148.535 17.6203 147.311 18.4302C146.088 19.2421 144.554 19.648 142.712 19.648H82.6987C82.6322 21.4191 82.2907 22.9386 81.6772 24.2056C80.9778 25.6525 79.9961 26.7783 78.7384 27.582C77.5011 28.3714 76.0552 28.8694 74.4007 29.077L73.6307 29.1731V25.9408L74.232 25.8672C75.3599 25.7271 76.3149 25.4009 77.1002 24.8917C77.858 24.3978 78.4418 23.6841 78.8519 22.7484C79.2773 21.777 79.4899 20.5213 79.4899 18.9824V9.75488H82.713V16.4475H142.379C143.66 16.4475 144.686 16.2031 145.454 15.7215C146.211 15.2439 146.771 14.5742 147.129 13.7081C147.51 12.797 147.7 11.7212 147.7 10.4819V9.79578H150.901H150.902Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M150.242 0.434315C149.834 0.104031 149.298 -0.0156073 148.639 0.0805124V0.0784673L148.265 0.122437L148.244 0.126527C147.543 0.252301 147.015 0.522254 146.661 0.936386C146.301 1.35665 146.121 1.92826 146.121 2.6512V3.09499L143.649 3.53059V5.73214L148.754 4.84457C149.436 4.72698 149.96 4.45293 150.328 4.02142C150.696 3.58786 150.882 3.0275 150.882 2.34035V1.94667C150.882 1.28508 150.669 0.780959 150.242 0.435337V0.434315ZM148.679 2.64711L148.325 2.70949V2.52747C148.325 2.44567 148.331 2.3792 148.343 2.3291C148.345 2.32296 148.347 2.31887 148.347 2.31478L148.68 2.2432V2.64711H148.679Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.546 0.0478516H71.3229V19.6471H74.546V0.0478516Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4203 8.71484C56.4192 8.71484 55.4151 8.84675 54.4099 9.11057C53.4006 9.37643 52.4384 9.7742 51.5273 10.3039C50.604 10.8397 49.7839 11.5177 49.0681 12.3367C48.3482 13.1599 47.7828 14.12 47.3645 15.2131C46.9463 16.3103 46.7367 17.5466 46.7367 18.9199V26.2342H49.9373V18.9199C49.9373 17.79 50.1428 16.7991 50.5569 15.9432C50.9711 15.0833 51.5325 14.3563 52.2401 13.7601C52.9579 13.1568 53.7637 12.6987 54.6533 12.3848C55.3394 12.1465 56.0409 11.9972 56.7567 11.943C56.8426 13.3603 57.1943 14.6098 57.8119 15.6958C58.54 16.975 59.6075 17.9566 61.0166 18.6428C62.3919 19.3125 64.0689 19.6479 66.0465 19.6479H68.5814V8.71484H57.4203ZM59.2916 11.351C59.2895 11.3111 59.2895 11.2712 59.2895 11.2313H59.2916V11.351ZM65.3594 16.429C63.6517 16.341 62.349 15.9095 61.4532 15.1354C60.6014 14.4033 60.1198 13.3306 60.0063 11.9144H65.3604V16.4279L65.3594 16.429Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M149.918 23.6943L147.119 26.5247L146.632 26.0308L145.001 24.3794L142.879 26.5247L142.391 26.0308L140.08 23.6943L142.879 20.9272L145.001 23.0224L147.119 20.9272L149.918 23.6943Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9071 49.773H53.6195V43.7604L46.7439 37.0801H52.6021L56.2628 40.8758L59.9154 37.0801H65.7735L58.9061 43.7604V49.773H58.9071Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4356 49.7728C72.3219 49.7728 70.0294 49.1286 68.56 47.8371C67.2613 46.6929 66.613 45.1335 66.613 43.16C66.613 41.1865 67.2613 39.6322 68.56 38.487C70.0294 37.1965 72.3219 36.5513 75.4356 36.5513C78.5493 36.5513 80.8449 37.1965 82.3153 38.487C83.6129 39.6322 84.2622 41.1896 84.2622 43.16C84.2622 45.1305 83.6129 46.6929 82.3153 47.8371C80.8449 49.1286 78.5513 49.7728 75.4356 49.7728ZM75.4356 46.3667C76.7138 46.3667 77.6515 45.9996 78.2497 45.2624C78.7272 44.6662 78.9665 43.9648 78.9665 43.159C78.9665 42.3532 78.7272 41.6507 78.2497 41.0597C77.6515 40.3183 76.7128 39.9472 75.4356 39.9472C74.1584 39.9472 73.2197 40.3183 72.6164 41.0597C72.1379 41.6507 71.8996 42.3512 71.8996 43.159C71.8996 43.9668 72.1379 44.6662 72.6164 45.2624C73.2187 45.9996 74.1595 46.3667 75.4356 46.3667Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M103.582 49.7729H98.5831C98.3551 49.4539 98.1935 49.0469 98.0994 48.551C98.0176 48.1675 97.8959 47.7933 97.7323 47.4262C97.5677 47.057 97.2844 46.7503 96.8816 46.5069C96.4817 46.2615 95.8856 46.1286 95.0972 46.1122H91.6614V49.774H86.3738V37.0811H94.9714C97.0278 37.0811 98.6864 37.2365 99.9461 37.5473C101.208 37.8561 102.129 38.3408 102.711 39.0045C103.292 39.6681 103.582 40.5352 103.582 41.6038C103.582 42.4944 103.38 43.2429 102.978 43.8503C102.578 44.4577 101.944 44.9383 101.077 45.2901C101.914 45.6377 102.455 46.0539 102.703 46.5417C102.953 47.0284 103.109 47.5642 103.17 48.1461C103.229 48.6665 103.367 49.2105 103.583 49.775L103.582 49.7729ZM91.6614 42.9791L94.6841 42.9709C95.5267 42.9709 96.1903 42.9331 96.6771 42.8574C97.1628 42.7797 97.5217 42.6744 97.7528 42.5425C97.9828 42.4116 98.1301 42.2644 98.1945 42.1018C98.2579 41.9402 98.2906 41.7735 98.2906 41.6017C98.2906 41.43 98.2579 41.2633 98.1945 41.0976C98.1301 40.933 97.9828 40.7847 97.7528 40.6528C97.5217 40.5189 97.1628 40.4135 96.6771 40.3379C96.1903 40.2602 95.5267 40.2203 94.6841 40.2203H91.6614V42.9791Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M125.454 49.7726H120.096L118.907 47.6938H110.96L109.776 49.7726H104.418L112.478 37.0879H117.39L125.454 49.7726ZM117.127 44.5535L114.938 40.7077L112.744 44.5535H117.127Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M150.949 49.773H145.661V41.6816L140.937 49.773H136.993L132.277 41.6816V49.773H126.99V37.0801H133.269L138.969 46.145L144.66 37.0801H150.948V49.773H150.949Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9604_4443",
    x1: 5.57801,
    y1: -2.6801,
    x2: 19.0777,
    y2: 25.4175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D946EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D927EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D427EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C829ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#B32DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9532E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7638E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9604_4443",
    x1: 8.49645,
    y1: 13.3165,
    x2: 19.6177,
    y2: 20.5919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7538E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5930BD",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#392793",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2483",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9604_4443",
    x1: 17.2055,
    y1: 27.6496,
    x2: 27.5813,
    y2: 49.2448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31237D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#312393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#3123B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#3123D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#3123E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3123E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9604_4443",
    x1: 31.0273,
    y1: 43.0158,
    x2: 21.2712,
    y2: 37.3835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2F2583",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#2E2483",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#2D2483",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2483"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9604_4443",
    x1: 31.5621,
    y1: -1.37226,
    x2: 26.0966,
    y2: 47.5813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67E4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#6CBAF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#7097F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#737BF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#7668F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#775CEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7859EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#794DEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#7B3EED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#7C3AED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#6D35D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#47299E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31237D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoramBigLogo);
export default __webpack_public_path__ + "static/media/yoram-big-logo.d105940bd212ce3835b3851da46f7afb.svg";
export { ForwardRef as ReactComponent };